import React, { useEffect, useState, useReducer } from "react"
import { graphql, PageProps } from "gatsby"

import Layout from "../../../components/Layouts/mainPage"
import { NewHeader } from "../../../components/Headers/NewHeader"
import { Banner } from "../../../components/Banners/Pkw"
import { Banner as RoundedDynamicBanner } from "../../../components/Banners/DynamicBanners/RoundedDynamicBanner"
import { FourAdvantagesPoints } from "../../../components/FourAdvantagesPoints"
import { InstallmentExample } from "../../../components/InstallmentExample"
import { ExampleWithLaptop } from "../../../components/InstallmentExample/Content/ExampleWithLaptop/ExampleWithLaptop"
import { HowSteps } from "../../../components/HowSteps"
import { FormPKW } from "../../../components/FormPKW"
import { NewCalculator } from "../../../components/NewCalculator"
import { MoreBenefitsRedisign } from "../../../components/MorBenefitsRedisgn"
import { BottomCta, RefinSeoBgImg } from "../../../components/BottomCta"
import { Partners } from "../../../components/PartnersNew"
import { Reviews } from "../../../components/Reviews"
import { Questions } from "../../../components/Questions"
import { NewFooter } from "../../../components/NewFooter"

import { getPageData } from "../../../helpers/getPageData"

import { PageData } from "../../../interfaces/pageProps"
import { sendScrollEventToDataLayer } from "../../../helpers/sendScrollEventToDataLayerPkw"
import { QUESTIONS_FOR_HALVA_OZON } from "../../../components/Questions/helpers"
import { ElectronicsImg } from "../../../components/InstallmentExample/img"
import { getSearchParam } from "../../../helpers/getSearchParam"
import { BannerText, getDynamicBannerText } from "../../../helpers/getDynamicBannerText"
import { getDynamicBannerUrl } from "../../../helpers/getDynamicBannerUrl"

const titleForm = (
  <>
    Оформите карту сейчас – <br /> получите подарок!
  </>
)

const bannerTitle = `
  <span>Карта «Халва»</span>
  <br/>
  от&nbsp;10 месяцев без&nbsp;% 
`

const bannerDescription = `
  на покупки у партнеров
`

const GIFT_TITLE = (
  <>
    Оформите Халву и получите
    <br />
    <b> месяц&nbsp;подписки&nbsp;в&nbsp;подарок</b>
  </>
)

const IDS = ["formPkw", "textBottomCalculator", "partners", "questions", "footer"]

type ObserverType = {
  formPkw: boolean
  textBottomCalculator: boolean
  partners: boolean
  questions: boolean
  footer: boolean
}

function observerReducer(state: ObserverType, action: any) {
  if (IDS.includes(action.id)) {
    return { ...state, [action.id]: action.value }
  }
  throw new Error()
}

// Время для таймер(30мин)
const countDownTime = 1800000

const initialObserverState: ObserverType = {
  formPkw: false,
  textBottomCalculator: false,
  partners: false,
  questions: false,
  footer: false,
}

export default function Page({ data }: PageProps<PageData>) {
  const { ligal, noIndex } = getPageData(data)
  const [observerState, observerDispatch] = useReducer(observerReducer, initialObserverState)

  const [dynamicBannerTextObj, setDynamicBannerTextObj] = useState<BannerText>()
  const [dynamicBannerImagesObj, setDynamicBannerImagesObj] = useState<any>()

  const bannerTextUrl = getSearchParam("h")
  const bannerImageUrl = getSearchParam("bn")

  useEffect(() => {
    if (bannerImageUrl) {
      const bannerImagesData = getDynamicBannerUrl(data.allDynamicBanner, bannerImageUrl)
      if (bannerImagesData !== null) {
        setDynamicBannerImagesObj(bannerImagesData)
      }
    }
  }, [data.allDynamicBanner, bannerImageUrl])

  useEffect(() => {
    if (bannerTextUrl) {
      getDynamicBannerText(bannerTextUrl).then((result) => {
        setDynamicBannerTextObj(result)
      })
    }
  }, [bannerTextUrl])

  const callback = (entries: IntersectionObserverEntry[]) => {
    for (let index = 0; index < entries.length; index += 1) {
      const element = entries[index]
      const { id } = element.target
      observerDispatch({ id, value: element.isIntersecting })
    }
  }

  useEffect(() => {
    Object.keys(observerState).forEach((key) => {
      if (observerState[key as keyof typeof initialObserverState]) {
        sendScrollEventToDataLayer(key)
      }
    })
  }, [observerState])

  useEffect(() => {
    const isSupported =
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    let observer: IntersectionObserver

    if (isSupported) {
      observer = new IntersectionObserver(callback)

      IDS.forEach((id) => {
        const element = document.getElementById(id)
        if (element) {
          observer.observe(element)
        }
      })
    }

    return () => {
      if (isSupported) {
        IDS.forEach((id) => {
          const element = document.getElementById(id)
          if (element) {
            observer.unobserve(element)
          }
        })
      }
    }
  }, [])

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  const [isTestActive, setIsTestActive] = useState(false)

  useEffect(() => {
    if ((globalThis as any).KameleoonExperiment_310087 === 1117724) {
      setIsTestActive(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(globalThis as any).KameleoonExperiment_310087 === 1117724])

  const subTitlePartners =
    bannerTextUrl === "rassrochka" || bannerImageUrl === "rassrochka" ? (
      <>
        Совершайте покупки в&nbsp;магазинах-партнерах и&nbsp;получайте от&nbsp;10&nbsp;месяцев
        рассрочки
      </>
    ) : (
      <>
        Совершайте покупки в&nbsp;магазинах-партнерах и&nbsp;получайте до&nbsp;24&nbsp;месяцев
        рассрочки
      </>
    )

  return (
    <Layout noHeader noFooter noIndex={noIndex}>
      <NewHeader redLogoWithSovcombank showHint={false} hasCTA countDownTime={countDownTime} />
      {dynamicBannerImagesObj && bannerImageUrl ? (
        <RoundedDynamicBanner
          large={dynamicBannerImagesObj.dymanicBannerDesk}
          mob={dynamicBannerImagesObj.dymanicBannerMob}
          title={dynamicBannerTextObj ? dynamicBannerTextObj.title : bannerTitle}
          description={dynamicBannerTextObj ? dynamicBannerTextObj.description : bannerDescription}
          variantStyle="halvaMedia"
          orderNum="1"
        />
      ) : (
        <Banner description={bannerDescription} title={bannerTitle} variant="pkw" orderNum="1" />
      )}
      <FourAdvantagesPoints
        withTitle
        variant="halvaMedia"
        title="Преимущества с Халвой:"
        orderNum="2"
      />
      <FormPKW
        dataLayerName="shortPersonalForm"
        title={titleForm}
        longTitle
        countDownTime={countDownTime}
        withTimer
        formBtnText="Оформить карту"
        orderNum="3"
        isGreenApprove
        progressBar
      />
      <HowSteps orderNum="4" />
      <NewCalculator orderNum="5" />
      <InstallmentExample
        variantStyle="halvaMedia"
        content={
          <ExampleWithLaptop
            logo={<ElectronicsImg alt="electronics" />}
            monthlyPayment="24 000 ₽"
            installmentPeriod="от 10 месяцев"
            totalCost="240 000 ₽"
            variantStyle="halvaMedia"
          />
        }
        orderNum="6"
        text="Бытовая техника и электроника без&nbsp;переплат"
      />
      <MoreBenefitsRedisign
        variant="halvaMedia"
        additionalEventInDataLayer
        bottomBlock={false}
        orderNum="7"
      />
      <BottomCta
        AB={isTestActive}
        variant="pkwRedesign"
        title={GIFT_TITLE}
        BgImg={RefinSeoBgImg}
        orderNum="8"
      />
      <Partners subTitle={subTitlePartners} orderNum="9" />
      <Reviews orderNum="10" />
      <Questions questionList={QUESTIONS_FOR_HALVA_OZON} orderNum="11" />
      <NewFooter ligal={ligal} orderNum="12" />
    </Layout>
  )
}

export const query = graphql`
  query {
    allDynamicBanner {
      edges {
        node {
          name
          deskGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [1920, 3840]
              )
            }
          }
          mobGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [600, 1200]
              )
            }
          }
        }
      }
    }
    admin {
      page(url: "https://halvacard.ru/order/halva/media/") {
        url
        ligal {
          text
        }
        notIndex
      }
    }
  }
`
